export default __webpack_public_path__ + "static/media/alientech.f32ffcb0.png";